import React from "react";
import { Avatar, IconButton, Stack, Typography } from "convertupleads-theme";
import { MoreVerticalIcon } from "../../../../common/Icons/Icons";

const NameAvatar = ({ children }) => {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <IconButton size={"small"}>
        <MoreVerticalIcon />
      </IconButton>

      {children}
      <Avatar
        size={"small"}
        alt="Remy Sharp"
        src="https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=580&q=80"
      />
      <Typography variant={"body2"}>Bruce Wayne</Typography>
    </Stack>
  );
};

export default NameAvatar;
